import Swiper from 'swiper';
import AOS from 'aos';
import enquire from 'enquire.js';

/**
 * Homepage vertical slider
 */
window.addEventListener('DOMContentLoaded', () => {
	var homeSlider = new Swiper('.home-container', {
		slidesPerView: 1,
		spaceBetween: 0,
		mousewheel: true,
		forceToAxis: true,
		sensitivity: 3,
		direction: 'vertical',
		pagination: {
			el: '.swiper-pagination'
		},
	});

	homeSlider.on('slideChange', function () {
		if(this.activeIndex == 0){
			$('#main-nav').removeClass('bg-dark');
		} else {
			$('#main-nav').addClass('bg-dark');
		}
	});
});
